import { useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState, useTransition } from 'react';
import style from './Config.module.css';
import classNames from 'classnames/bind';
import { Alert, Button, Toast } from '../../../../../components';
import { RefreshIcon, RestoreIcon, SquareIcon } from '../../../../../components/Icons/Icons';
import { getLine, getPolygon, getPolygonFire, getRoiList, listAiTranslate } from '../../../../../utils';
import axiosClient from '../../../../../services/axiosClient';
import { ReactPlayer } from '../../../../../components';
import { SettingAIContext } from '../../../../../contexts';
import { alprService } from '../../../../../services/api/alprService';
import { useTranslation } from 'react-i18next';
const cx = classNames.bind(style);

function ConfigZone() {
    const { nameService, cameraCode, codeService, permissionChange, onClose, setIsLoading, showReload,setShowReload } = useContext(SettingAIContext)
    const canvasRef = useRef(null);
    const [polygon, setPolygon] = useState({
        polygon1: [],
        polygon2: [],
        polygon3: []
    });
    const [canvas, setCanvas] = useState(null);
    const [roiListCode, setRoiListCode] = useState();
    const [draw, setDraw] = useState(false);
    const [alert, setAlert] = useState(false);
    const [reGetData, setReGetData] = useState(false);
    const [path, setPath] = useState();
    const [quality, setQuality] = useState({ width: 0, height: 0 });
    const [restore, setReStore] = useState(false);
    const [cropRegion, setCropRegion] = useState(0);
    const [defaultRoi, setDefaultRoi] = useState(false);
    const [items, setItems] = useState([])
    let width = 491;
    let height = 279;
    let cropX = width * cropRegion;
    let cropY = height * cropRegion;
    const [defaultShape, setDefaultShape] = useState();
    const findTopItem = (x, y) => {
        const item = items.filter(item => isInBounds(x, y, item)).pop();
        return item;
    };
    const { t } = useTranslation()

    const isInBounds = (x, y, item) => {
        // Check if the point (x, y) is inside the polygon defined by the item's points
        let { points } = item;
        let inside = false;
        for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
            const xi = points[i].x, yi = points[i].y;
            const xj = points[j].x, yj = points[j].y;
            const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    };

    const putItemOnTop = (item) => {
        setItems((prevItems) => {
            const index = prevItems.indexOf(item);
            const newItems = prevItems.slice();
            newItems.splice(index, 1);
            newItems.push(item);
            return newItems;
        });
    };
    useEffect(() => {
        if (cropRegion > 0) {
            setDefaultShape([
                { x1: 0 + cropX, y1: 0 + cropY, x2: 0 + cropX, y2: 0 + cropY, x1Control: 0 + cropX, y1Control: 0 + cropY, x2Control: 0 + cropX, y2Control: 0 + cropY },
                { x1: 0 + cropX, y1: 0 + cropY, x2: width - cropX, y2: 0 + cropY, x1Control: 0 + cropX, y1Control: 0 + cropY, x2Control: width - cropX, y2Control: 0 + cropY },
                { x1: width - cropX, y1: 0 + cropY, x2: width - cropX, y2: height - cropY, x1Control: width - cropX, y1Control: 0 + cropY, x2Control: width - cropX, y2Control: height - cropY },
                { x1: width - cropX, y1: height - cropY, x2: 0 + cropX, y2: height - cropY, x1Control: width - cropX, y1Control: height - cropY, x2Control: 0 + cropX, y2Control: height - cropY },
                { x1: 0 + cropX, y1: height - cropY, x2: 0 + cropX, y2: 0 + cropY, x1Control: 0 + cropX, y1Control: height - cropY, x2Control: 0 + cropX, y2Control: 0 + cropY },
            ])
        } else {
            setDefaultShape();
        }
    }, [cropRegion, cropX, cropY])
    const getConfigRoi = async (X, Y) => {
        try {
            const res = await axiosClient.get(`aiConfigRoiList/get-list-ai-config-roi-list/?camera_code=${cameraCode}&ai_service_code=${codeService}`);

            if (nameService.toLowerCase() === 'nhận dạng biển số xe') {
                const res2 = await alprService.getCrop({ camera_code: cameraCode })
                if (res2.length > 0 && res2[0].CROP_REGION && JSON.parse(res2[0].CROP_REGION).length > 0) {
                    setCropRegion(JSON.parse(res2[0].CROP_REGION)[0][0] / 100)
                } else {
                    setCropRegion(0)
                }
            }
            let data = {};
            res.forEach(item => {
                data = item;
            })
            if (res && res.length > 0) {
                setRoiListCode(data.CODE);
                const arr = getRoiList(data.ROI_LIST);
                setDefaultRoi(true);
                const { polygon1, polygon2, polygon3 } = getPolygon(arr, width, height);
                setPolygon({
                    polygon1: polygon1,
                    polygon2: polygon2,
                    polygon3: polygon3,
                })
            }
        } catch (error) {
            Toast.open(t('setting.Unable_to_extract_recognition_areas'), 'danger')
        }
        // eslint-disable-next-line
    }
    // Lấy cấu hình cảnh báo cháy
    const getFireConfigRoi = async () => {
        try {
            const res = await axiosClient?.get(`/aiConfigRoiList/get-list-ai-config-region-blocking/?camera_code=${cameraCode}`)
            const { polygon1, polygon2, polygon3 } = getPolygonFire(res?.region_block, width, height);
            setDefaultRoi(true);
            setPolygon({
                polygon1: polygon1,
                polygon2: polygon2,
                polygon3: polygon3,
            })
        } catch (error) {
            // // console.log(error);
            Toast.open(t('setting.Retrieving_fire_alarm_configuration_failed'), 'danger')
        }
    }
    const getPathStreaming = async () => {
        try {
            const res = await axiosClient.get(`camVideoQuality/get-cam-video-quality-for-config-roilist/?camera_code=${cameraCode}`)
            if (res && res.length > 0) {
                setPath(res[0].PATH);
                setQuality({ width: res[0].WIDTH, height: res[0].HEIGHT });
                return { width: res[0].WIDTH, height: res[0].HEIGHT };
            }
        } catch (error) {
            Toast.open(t('setting.No_images'), 'danger')
        }
    }

    useEffect(() => {
        setCanvas(canvasRef.current);
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const getData = async () => {
            if (canvasRef) {
                const res = await getPathStreaming();
                if (nameService?.toLowerCase() === 'cảnh báo cháy') {
                    await getFireConfigRoi()
                } else {
                    await getConfigRoi(res?.width, res?.height);
                }
            }
        }
        getData()
        // eslint-disable-next-line
    }, [canvasRef, reGetData, cameraCode, nameService])

    const drawPolygon = (ctx, lines) => {
        let xa, ya, xb, yb, x3, y3, x4, y4;
        lines.forEach((item, index) => {
            if (index === 0) {
                xa = item.x1Control;
                ya = item.y1Control;
            } else if (index === 2) {
                xb = item.x1Control;
                yb = item.y1Control;
            } else if (index === 3) {
                x3 = item.x1Control;
                y3 = item.y1Control;
            } else if (index === 4) {
                x4 = item.x1Control;
                y4 = item.y1Control;
            }
        });
        // Bắt đầu vẽ hình tứ giác
        ctx.beginPath();
        ctx.moveTo(xa, ya);
        ctx.lineTo(xb, yb);
        ctx.lineTo(x3, y3);
        ctx.lineTo(x4, y4);
        ctx.closePath();
        // Thiết lập màu và tô màu nền cho hình tứ giác
        ctx.fillStyle = nameService?.toLowerCase() === 'cảnh báo cháy' ? 'rgba(152, 1, 1, 0.04)' : 'rgba(0, 64, 255, 0.04)';
        ctx.fill();
    };

    const drawLine = (ctx, x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control, color) => {
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.strokeStyle = color;
        ctx.lineWidth = 2;
        // Vẽ điểm control
        const circle = new Path2D();
        circle.arc(x1Control, y1Control, 5, 0, 2 * Math.PI);
        circle.arc(x2Control, y2Control, 5, 0, 2 * Math.PI);
        ctx.fill(circle);
        ctx.fillStyle = color
    };

    const autoDraw = (lines) => {
        if (canvas) {
            const ctx = canvas.getContext("2d");
            for (let index = 0; index < 3; index++) {
                if (lines.length <= 5 && lines.length > 0) {
                    lines.forEach(({ x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control }) => {
                        drawLine(ctx, x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control, "white");
                    });
                    // Vẽ hình tứ giác khi đủ số lượng line
                    if (lines.length === 5) {
                        drawPolygon(ctx, lines);
                    }
                }
            }
        }
    }

    const drawDefaultPolygon = (lines) => {
        if (canvas) {
            const ctx = canvas.getContext("2d");
            for (let index = 0; index < 3; index++) {
                if (lines?.length <= 5 && lines?.length > 0) {
                    lines.forEach(({ x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control }) => {
                        drawLine(ctx, x1, y1, x2, y2, x1Control, y1Control, x2Control, y2Control, "red");
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (defaultRoi) {
            autoDraw(polygon.polygon1);
            autoDraw(polygon.polygon2);
            autoDraw(polygon.polygon3);
        }
    }, [polygon, defaultRoi])
    useEffect(() => {
        if (canvas) {
            if (cropRegion !== 0 && nameService.toLowerCase() === 'nhận dạng biển số xe' && defaultShape) {
                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                drawDefaultPolygon(defaultShape);
                autoDraw(polygon.polygon1);
                autoDraw(polygon.polygon2);
                autoDraw(polygon.polygon3);
            }
            else {
                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                // drawDefaultPolygon(defaultShape);
                autoDraw(polygon.polygon1);
                autoDraw(polygon.polygon2);
                autoDraw(polygon.polygon3);
            }
        }

    }, [canvas, cropRegion, nameService, defaultShape])

    const handleCanvasClick = (event) => {
        if (draw) {
            setShowReload(true)
            const { offsetX: x, offsetY: y } = event.nativeEvent;
            let { polygon1, polygon2, polygon3 } = polygon;
            if (polygon1.length < 6 && polygon1.length !== 5) {
                const line1 = getLine(x, y, polygon1)
                let poly1 = [...polygon.polygon1, ...line1];
                autoDraw(poly1);
                setPolygon(prev => ({ ...prev, polygon1: [...polygon1, ...line1] }))
            } else if (polygon2.length < 6 && polygon2.length !== 5 && polygon1.length === 5) {
                const line2 = getLine(x, y, polygon2)
                let poly2 = [...polygon.polygon2, ...line2];
                autoDraw(poly2);
                setPolygon(prev => ({ ...prev, polygon2: [...polygon2, ...line2] }));
            } else if (polygon3.length < 6 && polygon3.length !== 5 && polygon2.length === 5) {
                const line3 = getLine(x, y, polygon3);
                let poly3 = [...polygon.polygon3, ...line3];
                autoDraw(poly3);
                setPolygon(prev => ({ ...prev, polygon3: [...polygon3, ...line3] }));
            }
        }
        // eslint-disable-next-line
    }
    //  lấy tọa độ các điểm để đẩy lên API của dv thường
    const getListNorPoint = (polygon1, polygon2, polygon3) => {
        let data1 = [];
        if (polygon1.length === 5) {
            polygon1.shift();
            const arr = polygon1.map(item => {
                return [item.x1 * 100 / width, item.y1 * 100 / height];
            })
            data1.push(arr);
        }
        if (polygon2.length === 5) {
            polygon2.shift();
            const arr = polygon2.map(item => {
                return [item.x1 * 100 / width, item.y1 * 100 / height];
            })
            data1.push(arr);
        }
        if (polygon3.length === 5) {
            polygon3.shift();
            const arr = polygon3.map(item => {
                return [item.x1 * 100 / width, item.y1 * 100 / height];
            });
            data1.push(arr);
        }
        return data1;
    }
    //  lấy tọa độ các điểm để đẩy lên API của dv báo cháy
    const getListFirePoint = (polygon1, polygon2, polygon3) => {
        let data1 = [];
        if (polygon1.length === 5) {
            polygon1.shift();
            const arr = polygon1.map(item => {
                return [Number(item.x1 * 1000 / width).toFixed(0), Number(item.y1 * 1000 / height).toFixed(0)];
            })
            data1.push(arr);
        }
        if (polygon2.length === 5) {
            polygon2.shift();
            const arr = polygon2.map(item => {
                return [Number(item.x1 * 1000 / width).toFixed(0), Number(item.y1 * 1000 / height).toFixed(0)];
            })
            data1.push(arr);
        }
        if (polygon3.length === 5) {
            polygon3.shift();
            const arr = polygon3.map(item => {
                return [Number(item.x1 * 1000 / width).toFixed(0), Number(item.y1 * 1000 / height).toFixed(0)];
            });
            data1.push(arr);
        }
        return data1;
    }

    // x1 y1, x2 , y2
    const handleUpdate = async () => {
        let { polygon1, polygon2, polygon3 } = polygon;
        const data1 = nameService?.toLowerCase() === 'cảnh báo cháy' ? getListFirePoint(polygon1, polygon2, polygon3) : getListNorPoint(polygon1, polygon2, polygon3)
        const listPolygon = JSON.stringify(data1);
        try {
            setIsLoading(true)
            if (nameService?.toLowerCase() === 'cảnh báo cháy') {
                const data2 = await axiosClient.post('aiConfigRoiList/post-add-region-blocking/', {
                    camera_code: cameraCode,
                    region_blocking: {
                        data: listPolygon,
                    }
                })
            } else {
                if (nameService?.toLowerCase() === 'nhận dạng biển số xe') {
                    let xTopLeft = (defaultShape && defaultShape.length > 0 && defaultShape[1]) ? defaultShape[1].x1 : 0;
                    let yTopLeft = (defaultShape && defaultShape.length > 0 && defaultShape[1]) ? defaultShape[1].y1 : 0;
                    let xBottomRight = (defaultShape && defaultShape.length > 1 && defaultShape[3]) ? defaultShape[3].x1 : 0;
                    let yBottomRight = (defaultShape && defaultShape.length > 1 && defaultShape[3]) ? defaultShape[3].y1 : 0;
                    const infoCrop = (xTopLeft === 0 && yTopLeft === 0 && xBottomRight === 0 && yBottomRight === 0) ? [] : [[xTopLeft * 100 / width, yTopLeft * 100 / height], [xBottomRight * 100 / width, yBottomRight * 100 / height]];
                    // const checkValue = infoCrop.every((item)=>item ===0)
                    const crop_region = JSON.stringify(infoCrop);
                    const data2 = await axiosClient.post('camALPRCropRegion/post-add/', {
                        camera_code: cameraCode,
                        crop_region: {
                            data: crop_region,
                        }
                    })
                    // // console.log(data2);
                }
                await axiosClient.post('aiConfigRoiList/post-add-ai-config-roi-list/', {
                    ai_service_code: codeService,
                    camera_code: cameraCode,
                    roi_list: {
                        data: listPolygon,
                    }
                });
            }
            Toast.open(`${t('setting.Setting')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.success')}`, 'success');
            setIsLoading(false);
            setReGetData(!reGetData)
        } catch (error) {
            // // console.log(error);
            setIsLoading(false);
            Toast.open(`${t('setting.Setting')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.error')}`, 'danger');
        }
    }

    const handleDelete = () => {
        setAlert(!alert);
    }

    const handleDraw = () => {
        setShowReload(true)
        setDraw(!draw);
        setDefaultRoi(false);
    }

    useMemo(() => {
        if (restore && canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, 1000, 1000);
            setReStore(false);
            autoDraw(polygon.polygon1);
            autoDraw(polygon.polygon2);
            autoDraw(polygon.polygon3);
            drawDefaultPolygon(defaultShape);
        }
    }, [polygon, restore, canvas, cropRegion])

    const handleRestore = () => {
        let { polygon1, polygon2, polygon3 } = polygon;
        if (polygon3.length > 0) {
            setPolygon(prev => ({
                ...prev, polygon3: []
            }))
        } else if (polygon2.length > 0) {
            setPolygon(prev => ({
                ...prev, polygon2: []
            }))
        } else if (polygon1.length > 0) {
            setPolygon(prev => ({
                ...prev, polygon1: []
            }))
        }
        setReStore(true);
    }
    const reFreshConfig = async (code) => {
        if (nameService?.toLowerCase() !== 'cảnh báo cháy') {
            if (code) {
                try {
                    setIsLoading(true);
                    const res = await axiosClient.delete(`aiConfigRoiList/delete-remove-ai_config_roi_list/?ai_config_roi_list_code=${code}`);
                    Toast.open(`${t('setting.Reset_to_default')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} thành công`, 'success');
                    setReGetData(!reGetData)
                    setIsLoading(false);
                    setAlert(false);
                    return res;
                } catch (error) {
                    setIsLoading(false);
                    Toast.open(`${t('setting.Reset_to_default')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} không thành công`, 'danger');
                    setAlert(false);
                }
            } else {
                setReGetData(!reGetData)
                setAlert(false);
                setPolygon({
                    polygon1: [],
                    polygon2: [],
                    polygon3: []
                })
            }
            setReStore(true);
        } else {
            try {
                await axiosClient.post('aiConfigRoiList/post-add-region-blocking/', {
                    camera_code: cameraCode,
                    region_blocking: {
                        data: JSON.stringify([]),
                    }
                })
                Toast.open(`${t('setting.Reset_to_default')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} thành công`, 'success');
                setReGetData(!reGetData)
                setIsLoading(false);
                setAlert(false);
            } catch (error) {
                setIsLoading(false);
                Toast.open(`${t('setting.Reset_to_default')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} không thành công`, 'danger');
                setAlert(false);
            }
        }
    }

    useLayoutEffect(() => {
        if (canvas) {
            // Fix size off canvas if screen hight quality
            const dpr = window.devicePixelRatio;
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width * dpr;
            canvas.height = rect.height * dpr;
            const ctx = canvas.getContext("2d");
            ctx.scale(dpr, dpr);
            canvas.style.width = `${rect.width}px`;
            canvas.style.height = `${rect.height}px`;
            // Clear when remount or remove canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    }, [canvas]);


    const onChangeRegion = (e) => {
        let value = e.target.value;
        if (value === 0) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
        if (value > 0.5 || value < 0) {
            Toast.open("Gía trị bỏ nền từ 0 - 0.5", "danger");
        } else {
            setCropRegion(value)
            // setPolygon({
            //     polygon1: [],
            //     polygon2: [],
            //     polygon3: [],
            // })
        }
    }

    const handleCancel = () => {
        // onClose();
        setReGetData(!reGetData);
    }
    // // console.log('cropRegion', cropRegion);
    return (
        <>
            {alert && <Alert onClose={() => setAlert(!alert)} onOk={() => reFreshConfig(roiListCode)} title={` ${t('setting.Confirm_reset_to_default')}`} />}
            <div className={cx('list-config')}>
                <div className={cx('list-config-name')}>{
                    nameService?.toLowerCase() === 'cảnh báo cháy' ?
                        `${t('setting.Configure_the_area_without')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr?.toLocaleLowerCase() || nameService.toLowerCase()}` :
                        `${t('setting.Regional_configuration')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr?.toLocaleLowerCase() || nameService.toLowerCase()}`}
                </div>
                <div className={cx('draw-container')}>
                    <div className={cx('box-video')} style={{ width: `${width}px` }}>
                        {path ? (
                            <ReactPlayer
                                url={`${process.env.REACT_APP_BASE_URL}livestream${path}`}
                                // width={'100%'}
                                height={`${height + 1}px`}
                            // muted
                            // playing
                            // className={cx('react-player')}
                            />
                        ) : (
                            <div style={{ width: '100%', height: `${height + 1}px` }}>
                                <p className={cx('no-image')}>{t('location.cameraIsOff')}</p>
                            </div>
                        )}
                        <canvas
                            ref={canvasRef}
                            className={cx('canvas-space')}
                            style={{
                                width: '100%',
                                height: `${height}px`,
                            }}
                            onMouseDown={handleCanvasClick}
                        />
                    </div>
                </div>
                <div className={cx('controller-draw')}>
                    <div className={cx('left-button')}>
                        <button className={cx('button-control')} onClick={() => setReGetData(!reGetData)}>
                            {t("setting.Refresh_image")}
                            <RefreshIcon />
                        </button>
                        <button className={cx('button-control', draw && 'active')} onClick={handleDraw}>
                            {t("setting.Drawing")}
                            <SquareIcon />
                        </button>
                        {nameService.toLowerCase() === 'nhận dạng biển số xe' && (
                            <div className={cx('crop_region')}>
                                <p>{t("setting.Remove_background")}:</p>
                                <input
                                    type='number'
                                    max={0.5}
                                    min={0}
                                    step={0.1}
                                    className={cx("input_crop_region")}
                                    onChange={(e) =>{
                                        setShowReload(true)
                                        onChangeRegion(e)
                                    }}
                                    value={cropRegion}
                                />
                            </div>
                        )}
                    </div>
                    <div className={cx('right-button')}>
                        <button className={cx('button-control')} onClick={handleRestore}>
                            <RestoreIcon />
                        </button>
                    </div>
                </div>
            </div>
            {permissionChange && (
                <div className={cx("actions-setting")}>
                    <Button
                        onClick={handleDelete}
                        className={cx("btn-save")}
                        title={t('setting.Reset_to_default')}
                    />
                    {showReload && <Button className={cx("btn-cancle")} title={t('cameraControl.Cancel')} onClick={handleCancel} />}
                    <Button
                        onClick={handleUpdate}
                        className={cx("btn-save")}
                        title={t('settingCam.Save_settings')}
                    />
                </div>
            )}
        </>
    )
}

export default ConfigZone;